export const getReferralCountByCompany = `query GetReferralCountByCompany($companyId: ID!) {
    getReferralCountByCompany(companyId: $companyId) {
        companyId
        gdprReferralSent
        nongdprReferralSent
    }
  }`;
